import BaseErrorBoundary from 'personalization-lib/components/shared/errorHandling/boundaries/BaseErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const withInlineErrorHandling = (WrappedComponent, {
  errorFallback
} = {}) => props => /*#__PURE__*/_jsx(BaseErrorBoundary, {
  fallback: props.errorFallback || errorFallback,
  children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
});
export default withInlineErrorHandling;